export default {
  title: 'Indirizzo di consegna',
  buttons: {
    save: 'Salva',
  },
};
